import { AxiosRequestConfig } from 'axios'

export interface FrequencyByLevelParams {
  startDate: string
  endDate: string
  storeId?: number
  userType?: 'all' | 'recurrent'
}

export interface FrequencyByLevelStats {
  byLevel: Array<{
    nivel: string
    value: number
  }>
}

export interface FrequencyByLevelResponse {
  data: FrequencyByLevelStats
}

const getFrequencyByLevel = (params: FrequencyByLevelParams): AxiosRequestConfig => ({
  url: '/dashboard/frequency-by-level',
  method: 'GET',
  params,
})

export { getFrequencyByLevel }
